export default __webpack_public_path__ + "static/media/1696.189a15fc.png";